import React from 'react';
import ReactDOM from 'react-dom/client';
import { Demo } from './Demo';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Demo />
  </React.StrictMode>
);
